

    import {Vue, Options} from 'vue-class-component';

    @Options({
        Data() {
            return {
                username: "",
                fullname: "",
                email: ""
            }
        },
        methods: {
            get_user_info: function() {
                let username = localStorage.getItem('userusername');
                let fullname = localStorage.getItem('userfullname');
                let email = localStorage.getItem('useremail');

                this.username = username;
                this.fullname = fullname;
                this.email = email;
            }
        },

        beforeMount() {
            this.get_user_info()
        }
    })

    export default class UserInfo extends Vue {}

